import {SchemeLink} from '../../../applink/SchemeLink';
import {UrlLink} from '../../../applink/UrlLink';
import {getEnv} from '../../../common/env/env';
import {requestContext} from '../../../common/requestContext';

export function PrevTermsLink({
  url,
  linkLabel,
}: {
  url: string;
  linkLabel: string;
}) {
  const isWebview = requestContext.requestInfo.display.isWebView;
  return (
    <>
      {isWebview ? (
        <SchemeLink
          scheme={`kakaopage://open/browser?url=${getEnv().webOrigin}${url}`}
        >
          {linkLabel}
        </SchemeLink>
      ) : (
        <UrlLink url={url} shouldOpenNewTab>
          {linkLabel}
        </UrlLink>
      )}
    </>
  );
}
